document.addEventListener('DOMContentLoaded', function () {
  function getSelectedCurrency() {
    if (window.__heritageMarket && window.__heritageMarket.currency) {
      return window.__heritageMarket.currency;
    }

    var selectText = document.querySelector('.heritage-localization-form .localization-form__select-text');
    if (selectText) {
      var match = selectText.textContent.match(/·\s*([A-Z]{3})\b/);
      if (match) return match[1];
    }

    var legacySelected = document.querySelector('.Popover__ValueList button.is-selected');
    return legacySelected ? legacySelected.value : null;
  }

  function updateShippingNotices() {
    var selectedCurrency = getSelectedCurrency();
    var shippingNotices = document.querySelectorAll('.Cart__ShippingNotice.Text--subdued');

    shippingNotices.forEach(function (notice) {
      notice.style.display = selectedCurrency !== 'GBP' ? 'none' : '';
    });
  }

  updateShippingNotices();
  document.addEventListener('heritage:market:recover', updateShippingNotices);
});
